export default {
  'airport': 'Aéroport',
  'city': 'Ville',
  'cityCenter': 'Centre-ville',
  'companyLocation': 'A l\'entreprise',
  'district': 'Quartier',
  'fair': 'Fête foraine',
  'highway': 'Autoroute',
  'iata': 'IATA',
  'poi': 'Lieu d\'intérêt',
  'publicTransport': 'Transport public',
  'region': 'Région',
  'trainStation': 'Gare SNCF',
  'unknown': 'Inconnu',
  'ROLE_ADMIN': 'Admin',
  'ROLE_MANAGER': 'Manager',
  'ROLE_ACCOUNTANT': 'Comptable',
  'ROLE_USER': 'Utilisateur',
  'ROLE_BBA_AGENT': 'Agent BBA',
  'ROLE_BBA_ADMIN': 'Admin BBA',
  'REGLEMENT_SUR_PLACE':        "Paiement par le voyageur directement à l'hôtel",
  'VIREMENT_BBA':               "Virement BBA",
  'CARTE_VIRTUELLE_BBA':        "Carte virtuelle BBA",
  'DEBIT_CARTE_DE_CREDIT_BBA':  "Autorisation de débit sur carte bancaire BBA envoyée à l’hôtel",
  'DEBIT_AMERICAN_EXPRESS_BBA': "@:DEBIT_CARTE_DE_CREDIT_BBA",
  'DEBIT_CARTE_AIRPLUS_BBA':    "@:DEBIT_CARTE_DE_CREDIT_BBA",
  'DEBIT_CARTE_VIRTUELLE_BNP':  "@:DEBIT_CARTE_DE_CREDIT_BBA",
  'PREPAIEMENT_BBA':            "Prépaiement effectué par BBA",
  'PRISE_EN_CHARGE_BBA':        "Envoi de facture à BBA"
}
